import { Box, Container } from '@mui/material';
import React from 'react';
import { AppLogoTextWhite } from '../../../app/features/logo/AppLogo';
import LAppFullscreenBackground from '../../../app/layouts/LAppFullscreenBackground';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { globalConfig } from '../../../app/config/config';

const HomeIntroPage = () => {
	return (
		<LAppFullscreenBackground>
			<div style={{ width: '100%', textAlign: 'left', padding: '30px' }}>
				<Link to="/">
					<AppLogoTextWhite style={{ height: '60px' }} />
				</Link>
			</div>
			<Container>
				<Box
					style={{ height: 'calc(100vh - 130px)', width: '100%', textAlign: 'center' }}
					alignItems="center"
					justifyContent="center"
				>
					<ReactPlayer
						id="misc-player-video-tuto-player"
						url={globalConfig.get().APP_VIDEO_INTRO_EN}
						width="100%"
						height="60vh"
						controls
						config={{
							file: {
								attributes: {
									controlsList: 'nodownload',
								},
							},
						}}
					/>
				</Box>
			</Container>
		</LAppFullscreenBackground>
	);
};

export default HomeIntroPage;
